import React from "react";
import CommonModal from "./CommonModal";

const ConfirmModal = ({
  isOpen,
  title = "Confirm",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmClass = "btn-danger",
  onCancel,
  onConfirm
}) => {
  return (
    <CommonModal isOpen={isOpen} onClose={onCancel} elId="confirmModal">
      <div className="modal-header">
        <h5 className="modal-title">{title}</h5>
        <button className="btn-close" onClick={onCancel}></button>
      </div>

      <div className="modal-body">
        {message}
      </div>

      <div className="modal-footer">
        <button className="btn btn-secondary" onClick={onCancel}>
          {cancelText}
        </button>
        <button className={`btn ${confirmClass}`} onClick={onConfirm}>
          {confirmText}
        </button>
      </div>
    </CommonModal>
  );
};

export default ConfirmModal;
